import { SVGProps } from 'react';

const DrawRectangle = (props: SVGProps<SVGSVGElement>) => (
    <svg width="100%" height="100%" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g transform="matrix(1,0,0,1,-4347.32,-5.37263)">
            <g id="DrawRectangle" transform="matrix(1,0,0,1,-857.684,5.37263)">
                <g>
                    <g transform="matrix(0.494267,0,0,0.494267,1996.4,-273.771)">
                        <path
                            d="M6803.45,819.414C6798.94,815.599 6792.63,814.749 6787.27,817.235C6781.91,819.722 6778.48,825.092 6778.48,831L6778.48,929C6778.48,935.428 6782.53,941.159 6788.59,943.304C6794.65,945.449 6801.4,943.544 6805.45,938.548L6811.08,931.591C6811.08,931.591 6814.66,938.862 6814.66,938.862C6818.36,946.381 6827.46,949.475 6834.98,945.774L6856.51,935.173C6864.03,931.472 6867.12,922.376 6863.42,914.858L6860.53,908.98C6860.53,908.98 6867.87,909.044 6867.87,909.044C6874.26,909.101 6880,905.144 6882.23,899.151C6884.45,893.158 6882.68,886.413 6877.8,882.285L6803.45,819.414ZM6793.65,831L6793.65,929L6814.22,903.602L6828.27,932.16L6849.81,921.56L6836.04,893.59L6868,893.871L6793.65,831Z"
                            fill="#78787a"
                        />
                    </g>
                    <g transform="matrix(1,0,0,1,-1579.65,-780.195)">
                        <rect
                            x="6814"
                            y="805"
                            width="119.926"
                            height="112.16"
                            fill="none"
                            stroke="#78787a"
                            strokeWidth={7.5}
                            strokeDasharray="15,0.38,0,15"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export default DrawRectangle;
